import useSessionPersistedState from '../../hooks/useSessionPersistedState';

const DEFAULT_QUERY = { page: 0, size: 10 };

const useProductFilters = ({ persistKey } = {}) => {
  const [selectedFilter, setSelectedFilter] = useSessionPersistedState(
    persistKey ? `${persistKey}:selectedFilter` : undefined,
    'name',
  );
  const [searchTerm, setSearchTerm] = useSessionPersistedState(persistKey ? `${persistKey}:searchTerm` : undefined, '');
  const [currentQuery, setCurrentQuery] = useSessionPersistedState(
    persistKey ? `${persistKey}:currentQuery` : undefined,
    DEFAULT_QUERY,
  );

  const buildQuery = () => {
    const query = { ...currentQuery };

    query[selectedFilter] = searchTerm.trim();

    return query;
  };

  const handleFilterChange = (event) => setSelectedFilter(event.target.value);

  const handleSearchChange = (event) => setSearchTerm(event.target.value);

  const handlePaginationChange = (page, limit) => {
    setCurrentQuery({ ...currentQuery, page: page, size: limit });
  };

  const handleSearchKeyPress = (event) => {
    if (event.key === 'Enter') {
      setCurrentQuery(buildQuery());
    }
  };

  return {
    selectedFilter,
    searchTerm,
    currentQuery,
    handleFilterChange,
    handleSearchChange,
    handleSearchKeyPress,
    handlePaginationChange,
  };
};

export default useProductFilters;
